<template>
  <div class="container-fluid">
    <div>
      <div
        class="col-12 row justify-content-between container-partners__search pr-0 pl-0 ml-0 mb-3"
      >
        <div
          class="col-xs-mobile col-6 col-sm-6 col-md-7 col-lg-7 col-xl-7 pl-0"
        >
          <form class="d-flex form-partner">
            <i
              class="fas fa-search inputFilter md-filter-input fa-flip-horizontal"
            ></i>
            <input
              class="form-control inputFilter md-filter-input me-2"
              v-model="searchValue"
              type="text"
              placeholder="Buscar por nombre o correo electrónico"
              aria-label="Search"
              @keydown="searchPartnerInvitation"
            />


            <div class="md-layout md-gutter">
              <div class="md-layout-item" style="padding: 0px !important">
                <md-field class="sort-box select-partners">
                  <md-select
                    v-model="sortType"
                    class="custom-select filter inputFilter sort-select sort-portrait md-filter-input md-sort-select"
                  >
                    <md-option value="" selected hidden>Filtrar por</md-option>
                    <md-option value="newest">Nuevo</md-option>
                    <md-option value="oldest">Antiguo</md-option>
                    <md-option value="asc">A-Z</md-option>
                    <md-option value="desc">Z-A</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
          </form>
        </div>

        <div
          class="col-xs-mobile col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 pr-0"
        >
          <div>
            <button class="btn btn-course float-right" @click="openPartnerInvitationDialog">
              INVITAR SOCIO
            </button>
          </div>
        </div>
      </div>
      <div class="invitation-list">
        <div class="container-partners">
          <el-table
            v-if="isLoading"
            class="table-responsive table-flush"
            header-row-class-name="thead-light"
            :data="[1, 2, 3, 4]"
          >
            <el-table-column
              label="Correo electrónico"
              min-width="200px"
              prop="title"
              sortable
            >
              <template #default>
                <skeleton-square
                  :box-properties="{
                              height: '16px',
                              top: '10px',
                            }"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="Estado"
              min-width="150px"
              prop="title"
              sortable
            >
              <template #default>
                <skeleton-square
                  :box-properties="{
                              height: '16px',
                              top: '10px',
                            }"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="Fecha de invitación"
              min-width="150px"
              prop="title"
            >
              <template #default>
                <skeleton-square
                  :box-properties="{
                              height: '16px',
                              top: '10px',
                            }"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="Acciones"
              min-width="70px"
              prop="title"
              sortable
            >
              <template #default>
                <skeleton-square
                  :box-properties="{
                              height: '16px',
                              top: '10px',
                            }"
                />
              </template>
            </el-table-column>


          </el-table>
          <el-table
            v-else
            :data="getPartnerInvitations"
            class="table-responsive table-flush coupon-single"
            header-row-class-name="thead-light"
          >
            <el-table-column
              label="Correo electrónico"
              min-width="200px"
              prop="code"
              sortable
            >
              <template #default="{ row }">
                <div class="media align-items-center">
                  <div class="media-body">
                    <div class="font-weight-500 name mb-0 text-sm">
                      <div class="coupon-code">
                        <h3 class="mb-0 ml-2">{{ row.email }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Estado"
              min-width="150px"
              prop="expiration"
              sortable
            >
              <template #default="{ row }">
                <div class="media align-items-center">
                  <div class="media-body">
                    <badge
                      v-if="row.registered_at"
                      type="success"
                      class="status-active">activo
                    </badge>
                    <badge v-else type="secondary" class="status-pending">Pendiente
                    </badge>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Fecha de invitación"
              min-width="150px"
              prop="expiration"
              sortable
            >
              <template #default="{ row }">
                <div class="media align-items-center">
                  <div class="media-body">
                    {{ formatDate(row.created_at) }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Acciones" min-width="70px" prop="edit">
              <template #default="{ row }">
              <span class="mt-1">
                <md-menu :md-offset-x="-127" :md-offset-y="-20" md-size="auto">
                  <md-button md-menu-trigger>•••</md-button>
                  <md-menu-content>
                       <md-menu-item>
                      <span
                        class="pr-5 cursor"
                        href
                        @click="openPartnerResendInvitationDialog(row)"
                      >
                        Reenviar
                      </span>
                    </md-menu-item>
                    <md-menu-item>
                      <span
                        class="pr-5 cursor"
                        href
                        @click="openDeletePartnerInvitationDialog(row)"
                      >
                        Eliminar
                      </span>
                    </md-menu-item>
                  </md-menu-content>
                </md-menu>
              </span>
              </template>
            </el-table-column>
          </el-table>
          <div
            v-if="totalPages > 1"
            class="card-footer pt-4 pb-2 d-flex justify-content-end border-top-0"
          >
            <base-pagination
              :value="page"
              class="pagination-style"
              :page-count="totalPages"
              @input="paginationChange"
            ></base-pagination>
          </div>
        </div>
      </div>
    </div>
    <partner-invite-dialog
      :is-open="isOpenPartnerInviteDialog"
      @success="fetchPartnerInvitations"
      @close-modal="closePartnerInvitationDialog"
    />
    <delete-dialog
      :is-open="isOpenDeletePartnerInviteDialog"
      :is-loading="isLoadingDeletePartnerInviteDialog"
      @deleted="deletePartnerInvitation"
      @close-modal="closeDeletePartnerInvitationDialog"
    />
    <partner-invitation-resend-dialog
      :is-open="isOpenPartnerResendInviteDialog"
      :invitation="selectedInvitation"
      @close-modal="closePartnerResendInvitationDialog"
      @success="fetchPartnerInvitations"
    />
  </div>
</template>

<script>
//import Modal from "@/components/Modal.vue";

import { DELETE_INVITATION_PARTNER, PARTNER_INVITATION_LIST } from '@/store/actions/partner';
import { mapGetters } from 'vuex';
import PartnerInviteDialog from '@/views/Pages/Admin/Partner/components/PartnerInviteDialog';
import PartnerInvitationResendDialog from '@/views/Pages/Admin/Partner/components/PartnerInvitationResendDialog.vue';
import {
  Table,
  TableColumn,
} from 'element-ui';
import moment from 'moment-timezone';
import SkeletonSquare from '@/components/Skeleton/components/SkeletonSquare.vue';
import DeleteDialog from '@/views/Pages/Admin/components/DeleteDialog.vue';

export default {
  name: 'ListPartner',
  components: {
    DeleteDialog,
    SkeletonSquare,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PartnerInviteDialog,
    PartnerInvitationResendDialog

  },
  data: () => ({
    isLoading: true,
    isOpenPartnerInviteDialog: false,
    isOpenPartnerResendInviteDialog: false,
    isOpenDeletePartnerInviteDialog: false,
    isLoadingDeletePartnerInviteDialog: false,
    searchValue: null,
    sortType: '',
    isFilter: false,
    active: false,
    value: null,
    modals: {
      updatePartner: false,
      deletePartner: false,
    },
    email: null,
    selectedInvitation: undefined,
    preview: {
      avatar: {
        view: false,
        img: '',
      },
      thumbnail_header: {
        view: false,
        img: '',
      },
      thumbnail_vertical: {
        view: false,
        img: '',
      },
    },
    page: 1,
  }),
  computed: {
    ...mapGetters(['getPartnerInvitations']),
    totalPages () {
      return Math.ceil(this.getPartnerInvitations.total / this.perPage);
    },
  },
  watch: {
    sortType: function(newValue) {
      this.isLoading = true;
      this.fetchCoupons({
        search: this.searchValue,
        per_page: 20,
        order_by: newValue,
      });
    },
  },
  mounted () {
    this.fetchPartnerInvitations();
  },
  methods: {
    moment,
    openPartnerResendInvitationDialog (item) {
      this.selectedInvitation = item;
      this.isOpenPartnerResendInviteDialog = true;
    },
    closePartnerResendInvitationDialog () {
      this.selectedInvitation = undefined;
      this.isOpenPartnerResendInviteDialog = false;
    },
    openPartnerInvitationDialog () {
      this.isOpenPartnerInviteDialog = true;
    },
    closePartnerInvitationDialog () {
      this.isOpenPartnerInviteDialog = false;
    },

    searchPartnerInvitation (event) {
      if (event.key === 'Enter') {
        this.fetchPartnerInvitations();
      }
    },
    openDeletePartnerInvitationDialog (item) {
      this.selectedInvitation = item;
      this.isOpenDeletePartnerInviteDialog = true;
    },
    closeDeletePartnerInvitationDialog () {
      this.selectedInvitation = undefined;
      this.isOpenDeletePartnerInviteDialog = false;
    },
    formatDate (date) {
      return moment.tz(date, 'America/New_York').format('MMMM D YYYY, h:mm:ss a');
    },
    fetchPartnerInvitations (
      filter = {
        search: this.searchValue,
        per_page: 20,
        order_by: this.sortType,
      },
    ) {
      this.isLoading = true;
      this.$store
        .dispatch(PARTNER_INVITATION_LIST, filter)
        .then(() => (this.isLoading = false))
        .catch(() => (this.isLoading = false));
    },
    deletePartnerInvitation () {
      this.isLoadingDeletePartnerInviteDialog = true;
      this.$store
        .dispatch(DELETE_INVITATION_PARTNER, this.selectedInvitation.id)
        .then(() => {
          this.isLoadingDeletePartnerInviteDialog = false;

          this.notify('success', 'Se ha eliminado la invitación correctamente');
          this.fetchPartnerInvitations();
          this.closeDeletePartnerInvitationDialog();
        })
        .catch(() => {
          this.isLoadingDeletePartnerInviteDialog = false;
          this.notify('danger', 'Tenemos problemas para eliminar la invitación');
        });
    },
    async paginationChange (page) {
      this.isLoading = true;
      this.page = page;
      await this.$store.dispatch(PARTNER_INVITATION_LIST, {
        page: this.page,
        per_page: this.perPage,
      });
      this.isLoading = false;
    },
    notify (type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
  },

};
</script>
